module.exports = __webpack_public_path__ + "img/gcpp_logo.d92b4fde.png";